// extracted by mini-css-extract-plugin
module.exports = {"savingModal":"savingModal_savingModal__2iO3D","content":"savingModal_content__2lHCA","rotation":"savingModal_rotation__12pw6"};